import { KitSpinner } from "@chargepoint/cp-toolkit";

const Spinner = ({ visible }: { visible: boolean }) => {
  return <KitSpinner withOverlay size="m" show={visible} />;
};

export default Spinner;
